import React, { useRef } from 'react'
import { Trans, t } from '@lingui/macro'
import { useClipboard } from 'use-clipboard-copy'
import { linkBuilder } from 'shared/linkBuilder'
import { notification } from 'front-end/src/components/common/notifications/Notifications'
import {
  useCreateGroupSelfSignupLinkMutation,
  useGroupSelfSignupLinkQuery
} from './GroupSelfSignupLink.codegen'
import { useParams } from 'react-router-dom'
import {
  Box,
  ButtonIcon,
  ButtonPrimary,
  Center,
  Spinner
} from 'front-end/src/components'
import { Textarea } from '@chakra-ui/react'
import IconShare from 'front-end/src/components/common/icon/IconShare'
import IconCopy from 'front-end/src/components/common/icon/IconCopy'

export const GroupSelfSignupLink = () => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null)
  const clipboard = useClipboard()
  const params = useParams<{
    groupId: string
  }>()

  const groupId = +params.groupId
  const { data, loading, refetch } = useGroupSelfSignupLinkQuery({
    variables: {
      groupId
    }
  })

  const [createNewLink, { loading: creating }] =
    useCreateGroupSelfSignupLinkMutation({
      variables: {
        groupId
      }
    })

  if (loading) {
    return <Spinner />
  }
  const secretSignupLinks = data?.admin?.group?.secretSignupLinks
  let link: string | null = null

  if (secretSignupLinks && secretSignupLinks.length > 0) {
    link = `${location.origin}${linkBuilder.secretSelfSignup(
      secretSignupLinks[0].token
    )}`
  }

  return (
    <Box>
      <Box w="100%" mb="10px" textAlign="left">
        <IconShare />
        {` `}
        <Trans>Direct sign up link</Trans>
      </Box>

      {link ? (
        <div className="access-link-textarea">
          <Textarea
            ref={textAreaRef}
            className="setting-textarea"
            value={link}
            readOnly
            bgColor="white"
            minW="286px"
          />

          <ButtonIcon
            hint={t`Copy to clipboard`}
            aria-label={t`Copy to clipboard`}
            circular
            onClick={() => {
              clipboard.copy(link)
              notification.info(t`Successfully copied to clipboard`)
            }}
            icon={<IconCopy boxSize="16px" />}
          />
        </div>
      ) : (
        <Center>
          <ButtonPrimary
            isLoading={creating}
            onClick={async () => {
              await createNewLink()
              await refetch()
            }}
          >
            <Trans>Generate new link</Trans>
          </ButtonPrimary>
        </Center>
      )}

      <div className="DrawerItem__hint">
        <Trans>
          When signing up with this link, users will automatically be added to
          this group
        </Trans>
      </div>
    </Box>
  )
}
